import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { useApplicationSize } from '../../../providers/providers-application';
import { ReceiptModalContext } from './ReceiptModalContext';
export const ReceiptContext = createContext(null);
/**
 * When the receipt is displayed on a small device in a modal (ReceiptModal) the colorContext should be ignored.
 */
export const ReceiptProvider = ({ children, colorContext }) => {
    const modalContext = useContext(ReceiptModalContext);
    const applicationSize = useApplicationSize();
    return (_jsx(ReceiptContext.Provider, { value: {
            colorContext: modalContext && applicationSize === 'small' ? 'on-light' : colorContext,
        }, children: children }));
};
export const useReceiptContext = () => {
    const context = useContext(ReceiptContext);
    if (context === null) {
        throw new Error('useReceiptContext must be used within a ReceiptContext');
    }
    return context;
};
